<template lang="pug">
.card-info.card-info--left.col-2.d-none.d-lg-block
    .card-container
        .card-container__header.p-3
           
            h5.mb-2 {{ deliveryDataGet.storeName }}
            .card-container__header__store-address {{ deliveryDataGet.orderFrom }}
            template(v-if='deliveryDataGet.deliveryTo!== "" ')
                hr
                h5 {{ $t("deliveryInfo.deliveryTo") }}
                .mb-2 {{ deliveryDataGet.deliveryTo }}
            template(v-if='!appSetting.useFeatureTakeaway ')
                .mb-2 {{ $t("deliveryInfo.OrderTime") + ":" }} {{ deliveryDataGet.orderTime | formatTime }}
                .mb-2 {{ $t("deliveryInfo.estimatedDeliveryTime")+ ": " }} {{ estimateTime | formatTime }}
            hr
            h5 {{ $t("deliveryInfo.yourOrderNo") + ": #" + deliveryDataGet.orderNo }}
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import popup from "@/components/mixins/popup";

export default {
    name: "DeliveryInfo",
    mixins: [popup],
    filters: {
        formatTime(value) {
            if (value == undefined || value == "") return "";
            return moment(String(value)).format("HH:mm");
        }
    },
    data() {
        return {
            dataTemp: {},
            isShow: true,
            modalShow: true,
           
        };
    },
    computed: {
        ...mapGetters(["deliveryDataGet", "selectedStoreGet"]),
        ...mapGetters({
            appSetting: "settingGet",
            appMisc: "miscGet"
        }),
        estimateTime: function() {
            return moment(this.deliveryDataGet.servsTime);
        }
    },
    watch: {
        // data: function (deliveryInfo) {
        //     this.dataTemp = deliveryInfo;
        //     this.IsShow = true;
        //     // Return data from component
        //     // setTimeout(() => {
        //     //     this.$emit("callback", this.dataTemp);
        //     // }, 100);
        // },
    },

    created() {
        // this.deliveryEstimate = moment(this.deliveryDataGet.servsTime);
    },
    mounted() {
    },

    methods: {
    }
};
</script>
